export default class Product {
  display;
  set;

  constructor(cellWire, shortNames) {
    this.display = (shortNames ? cellWire.c_dsp : cellWire.cell_dto_display) || "";
    this.set = shortNames ? cellWire.c_set : cellWire.cell_dto_set;
  }
}
